import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import {style} from '../../components/pdf/fontstyles';
import {AutoText} from '../../components/pdf/autoText'; 



const styles = StyleSheet.create({
    
          solidLine: {
           
            borderBottomWidth: 1,   // thickness of the line
            borderBottomColor: '#000', // color (black here)
            width: '100%',         // full width of page or container
          },

          table: {
            
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          srNoCell: {
            width: '5%', // First column with smaller width
          },
          detailsCell: {
            width: '55%', // Second column with larger width
          },
          pageNoCell: {
            width: '40%', // Third column with medium width
          },

          bulletRow: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 2, // space between bullet points
          },
          bulletSymbol: {
            width: 10, // fixed width for bullet
            fontSize: 10,
            marginRight: 5, // gap between bullet and text
          },
          bulletText: {
            flex: 1,
            textAlign: 'justify',
          },
          


        });


        
        
const Form5 = ({ result }) => {

    const tableData = [
        ['1', 'Name of the Government servant', result.employeeName],
        ['2', 
          `a) Date of birth\nb) Date of Retirement.`,
         `${result.dateOfBirth}\n${result.dateOfRetirement}`
        ],
        ['3', 
          'Specimen signatures, finger impressions (to be furnished in a separate sheet) duly attested by a Gazetted Government servant.', 
          'Attached'
        ],
        ['4', 
          'Copy of passport size joint photograph with wife or husband (To be attested by the Head of Office)', 
          'Attached'
        ],
        ['5', 
          'Two slips showing the particulars of height and personal +identification marks duly at tested by a Gazetted Government servant.', 
          'Attached'
        ],
        ['6', 'Present address', result.address],
        ['7', 'Address after retirement', 'As above'],
        ['8', 'Name of the Government Treasury or Branch of Public Sector Bank through which the pension is to be drawn.', result.treasury],
        ['9', 'Details of the family Form 3', 'Attached'],
      ];
      
  
  return (
              <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBlack]}>FORM - 5</Text>
                <Text style={[style.subtitle]}>[See Rules 121(1)(c) and 123 (1)]</Text>
                <Text style={[style.subtitle, { fontSize: 10 }]}>
                Particulars to be obtained by the Head of Office from the retiring Government servant eight months before the date of his/her retirement.
                </Text>
    
              <View style={[style.solidLine,{marginBottom: 10}]} />

               {/* Table */}
                   <View style={styles.table}>
                    
                     {/* Table Data */}
                     {tableData.map(([srNo, details, value], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                        <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
                      </View>
                    ))}
              </View>


              <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>
              <Text style={{ marginTop: 5 }}>Date:</Text>

                
            <View style={styles.solidLine} />


          {/* Point 1 */}
      <View style={{fontSize: 8}}>
            <View style={[styles.bulletRow, {marginTop: 20}]}>
            <Text style={styles.bulletSymbol}>•</Text>
            <Text style={styles.bulletText}>
                Slip each bearing the left-hand thumb and finger impressions, duly attested, may be furnished by a person who is not literate enough to sign his name. If such a Government servant, on account of physical disability, is unable to give left-hand thumb and finger impressions, impressions of the right hand should be furnished. Where a Government servant has lost both hands, impressions of the available limb may be furnished. All impressions should be duly attested by a Gazetted Government servant.
            </Text>
            </View>

            {/* Point 2 */}
            <View style={styles.bulletRow}>
            <Text style={styles.bulletSymbol}>•</Text>
            <Text style={styles.bulletText}>
                Copies of passport-size photographs of self only need to be furnished:
                {"\n"}(i) If the Government servant is governed by Rule 115 of the Maharashtra Civil Services (Pension) Rules, 1982 and is unmarried, a widower, or a widow.
                {"\n"}(ii) If the Government servant is governed by Rule 117 of the Maharashtra Civil Services (Pension) Rules, 1982.
            </Text>
            </View>

            <Text style={styles.paragraph}>
            Where it is not possible for a Government servant to submita photograph with his wife or her husband, he or she may submit separate photographs.  The photographs shall be attested by the Head of Office.
            </Text>

        {/* Point 3 */}
         <View style={styles.bulletRow}>
            <Text style={styles.bulletSymbol}>•</Text>
            <Text style={styles.bulletText}>
            	Applicable only where rule 116 of Maharashtra Civil Services (Pension) Rules 1982 applies of the Government servant.
            </Text>
            </View>
        </View>
              </View>

);
};

export default Form5;